export default "__VITE_ASSET__DCu5tNvt__"